<p-toast position="top-right"></p-toast>
<div class="ui-g">
  <div class="ui-g-12">
    <form #BookingSlotForm="ngForm">
      <div class="ui-g-12">
        <p-toolbar>
          <div class="ui-toolbar-group-left">
            <!-- <button routerLink="booking-slot" pButton type="button" label="New" icon="pi pi-plus"></button> -->
            <button (click)="save()" [disabled]="!BookingSlotForm.valid" pButton *ngIf="mode == 'add'" type="button"
              [label]='setLabel("saveBtnLabel")' icon="pi pi-save" class="ui-button-success"></button>&nbsp;
            <button (click)="update()" [disabled]="!BookingSlotForm.valid" pButton *ngIf="mode == 'edit'"
              type="button" [label]='setLabel("updateBtnLabel")' icon="pi pi-save" class="ui-button-success"></button>&nbsp;
          </div>
        </p-toolbar>
      </div>
      <p-tabView>
          <div class="card card-w-title">
            <div class="ui-g-12">
              <form #BookingSlotForm="ngForm">
                <div class="ui-g-6" style="text-align: left">
                  <h3 class="first">{{setLabel("bookingDetailLabel")}}</h3>
                  <div class="ui-g ui-fluid">
                    <div class="ui-g-12">
                      <div class="ui-inputgroup">
                        <span class="ui-inputgroup-addon"><i class="fa fa-user" aria-hidden="true"></i></span>
                        <input type="text" pInputText [placeholder]='setLabel("searchBySlotNamePlaceholderLabel")' name="name" #name="ngModel"
                          [(ngModel)]="Booking.name" required pattern="[A-Za-z ]+"
                          [ngClass]="name.invalid && (name.dirty || name.touched) ? 'errorInput' : '' ">
                      </div>
                      <div *ngIf="name.invalid && (name.dirty || name.touched)">
                        <div *ngIf="name.errors.required" class="errorShow">
                          {{setLabel("nameRequiredErrorLabel")}}
                        </div>
                        <div *ngIf="name.errors.pattern" class="errorShow">
                          {{setLabel("charactersAllowedErrorLabel")}}
                        </div>
                      </div>
                    </div>
                    <h3 class="first">{{setLabel("filledSlotsLabel")}}</h3>
                    <div class="ui-g-12">
                      <div class="ui-inputgroup">
                        <span class="ui-inputgroup-addon"><i class="fa fa-money" aria-hidden="true"></i></span>
                        <input type="number" [placeholder]='setLabel("searchByStatusPlaceholderLabel")' pInputText #status="ngModel"
                          name="status" [(ngModel)]="Booking.status" required autocomplete="off" pattern="[0-9]+"
                          [ngClass]="status.invalid && (status.dirty || status.touched) ? 'errorInput' : '' ">
                      </div>
                      <div *ngIf="status.invalid && (status.dirty || status.touched)">
                        <div *ngIf="status.errors.required" class="errorShow">
                          {{setLabel("filledSlotsCorrectlyErrorLabel")}}
                        </div>
                        <div *ngIf="status.errors.pattern" class="errorShow">
                          {{setLabel("filledSlotsCorrectlyErrorLabel")}}
                        </div>
                      </div>
                    </div>

                  </div>
                </div>
                <div class="ui-g-6" style="text-align: left">
                <h3 class="first">{{setLabel("bookingNo:Label")}}</h3>
               <div class="ui-g-12">
                 <div class="ui-inputgroup">
                   <span class="ui-inputgroup-addon"><i class="fa fa-envelope-o" aria-hidden="true"></i></span>
                   <input type="number" required pInputText
                     autocomplete="off"
                     [ngClass]="bookingnumber.invalid && (bookingnumber.dirty || bookingnumber.touched) ? 'errorInput' : '' "
                     [placeholder]='setLabel("searchByTotalSlotPlaceholderLabel")' name="bookingnumber" #bookingnumber="ngModel" [(ngModel)]="Booking.bookingnumber">
                 </div>
                 <div *ngIf="bookingnumber.invalid && (bookingnumber.dirty || bookingnumber.touched)">
                   <div *ngIf="bookingnumber.errors.required" class="errorShow">
                    {{setLabel("bookingNoReuiredLabel")}}
                   </div>
                 </div>
               </div>
               <br />
                 <h2>{{setLabel("startTimeSlotLabel")}}</h2>
                 <hr>
                 <!-- <div class="ui-g-12 ui-md-3">
                   <h3>From :</h3>
                   <p-calendar name="startTime" [(ngModel)]="BookingSlot.startTime" [hourFormat]="12" required [timeOnly]="true"></p-calendar>
                 </div>
                 <div class="ui-g-12 ui-md-3">
                   <h3>To :</h3>
                   <p-calendar name="endTime" [(ngModel)]="BookingSlot.endTime" required [hourFormat]="12" [timeOnly]="true"></p-calendar>
                 </div> -->
                </div>
              </form>
            </div>
            <div style="clear: both;"></div>
          </div>

      </p-tabView>
    </form>
  </div>
</div>
